import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
  SheetFooter,
  SheetClose,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { FC, useState } from 'react';
import { OrganizationForm } from './OrganizationForm';
import { trpc } from 'src/trpc';

export const NewOrganizationDrawer: FC = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isFormDirty, setIsFormDirty] = useState(false);
  const utils = trpc.useUtils();

  const handleSuccess = async () => {
    await utils.admin.organization.getAllOrganizations.invalidate();
    setOpenDrawer(false);
  };

  const canSave = isFormValid && isFormDirty;

  return (
    <Sheet open={openDrawer} onOpenChange={setOpenDrawer}>
      <SheetTrigger asChild>
        <Button variant={'default'} className="text-white">
          Create New Organization
        </Button>
      </SheetTrigger>
      <SheetContent className="p-0 sm:max-w-[600px] lg:max-w-[700px] xl:max-w-[800px] h-full">
        <div className="grid h-full grid-rows-[auto_1fr_auto]">
          {/* Header */}
          <SheetHeader className="border-b bg-white px-6 py-4">
            <SheetTitle className="text-left text-lg font-semibold text-gray-900">
              Create New Organization
            </SheetTitle>
          </SheetHeader>

          {/* Content Area - Scrollable */}
          <div className="overflow-y-auto px-6 py-6">
            <OrganizationForm
              onSuccess={handleSuccess}
              onStateChange={(state) => {
                setIsFormValid(state.isValid);
                setIsFormDirty(state.isDirty);
              }}
            />
          </div>

          {/* Footer - Always Visible */}
          <SheetFooter className="border-t bg-gray-50 px-6 py-4">
            <div className="flex w-full justify-end gap-4">
              <SheetClose asChild>
                <Button variant="outline" className="w-full sm:w-auto">
                  Cancel
                </Button>
              </SheetClose>
              <Button
                disabled={!canSave}
                className="w-full sm:w-auto text-white bg-orange-600 hover:bg-orange-700"
                type="submit"
                form="organization-form"
              >
                Create Organization
              </Button>
            </div>
          </SheetFooter>
        </div>
      </SheetContent>
    </Sheet>
  );
};
